import { useMutation, useQueryClient } from "react-query";
import { useUser } from "@/providers/context";
import { putWatchlistItem, UpdateDefaultPlaylist } from "@/api";
import { AxiosError } from "axios";

export const usePutWatchlistItem = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();
  return useMutation<
    unknown,
    AxiosError<{ error: string }>,
    Omit<UpdateDefaultPlaylist, "UserId">
  >(
    async (watchlistItem) => {
      if (uid) {
        return await putWatchlistItem({ ...watchlistItem, UserId: uid });
      }
    },
    {
      onSuccess: (data) => {
        // Update the local watchlist immediately with the response
        if (data) {
          queryClient.setQueryData(["watchlist", uid], data);
        }
      },
    },
  );
};
